import { useNavigate } from 'react-router-dom';
import { DiscountCards } from '../../../dummyData/homePage';
import './discount.css';
import { useState } from 'react';

const DiscountSection = () => {
    const navigate = useNavigate();
    const [limit] = useState(9);

    const handleNavigate = (path) => {
        navigate(`/search-result/trip/${path}`, {
            state: { limit }
        });
    };
    return (
        <div className='customContainer'>
            <div className='discountSection'>
                {DiscountCards.map((item) => {
                    return (
                        <img
                            key={item.id}
                            src={item.image}
                            alt={item.description}
                            onClick={() => handleNavigate(item.path)}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default DiscountSection;
